{
  "en": {
    "groupJoinForm": {
      "label": "8-digit activation code",
      "placeholder": "Enter code",
      "submit": "Activate license",
      "error": "The code you entered is invalid.",
      "invalidFormat": "Please enter a valid 8-digit code.",
      "alreadyMember": "You are already a member of this group."
    }
  }
}
